import type { FaireProductEntity } from "../../entity_types/product";

export const p_q758ypuzf6: FaireProductEntity = {
  token: "p_q758ypuzf6",
  type: "product",
  name: "Jacob Protein Bar - Grass-Fed Organic Snack Bar (9ct)",
  brandToken: "b_3usc9fbjsg",
  brandName: "Jacob",
  imageUrl:
    "https://cdn.faire.com/fastly/98fbe41d8d4c9046762a0b2a7d9423dfcf13c7a1cfad50b415a7fbcb28eaaf0d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ea5426c87a30e4082f687a4aa08af7533296be82869772b16d15b7b02970f09b.png",
    "https://cdn.faire.com/fastly/407f6c1376ab4060190304ad06e691072cee7c20a0b61a3b0b5da32f3a4e93b5.png",
    "https://cdn.faire.com/fastly/836d770c00439e6bcb631a3355190f44dd18618a882a80fcc8aeb956eec4d73c.png",
    "https://cdn.faire.com/fastly/bca49a1b70a961a52c7d2addfbcd7d9b69a7c27b6c2eef0e88e7219c18c8a469.png",
    "https://cdn.faire.com/fastly/002a9d7efe7e8b64a04f6a4eb3d6999fc7838e7448ea56b80af0ec04fde6f2b6.png",
    "https://cdn.faire.com/fastly/390b99a2ac6450cd83f3be2deadcd7e8ee635b552d10dc17298f201eb6245d5b.png",
    "https://cdn.faire.com/fastly/af2fe31d1a01b44c0f1be4206019ab9fa954217afa4caceb5a7b784816c30774.png",
  ],
  priceDollars: 31.5,
  description:
    'I was sick and tired of compromising my healthy diet and lifestyle when on the go. I created the Jacob bar because we wanted to have fuel that was high in protein but still made with real ingredients.\n\nGrass-Fed Protein: we use whey protein isolate, milk protein isolate, and bovine collagen to power our bars.\n\nGrass-Fed Beef Tallow: the highest-quality fat source, beef tallow, is at the base of our bars. This healthy fat will leave you satiated (and give the bar an amazing texture).\n\nOrganic Honey and Dates: we use nature\'s sweetness and avoid artificial or "natural" sweeteners. The combination of pure honey and dates leaves a wonderful blend of sweetness.\n\n100% Organic Cacao: Our Vanilla Chip and Chocolate Chip flavors have 100% organic cacao chips for added texture (yummy).\n\nOrganic Pure Madagascar Vanilla Powder & Extract: We don\'t use any artificial or "natural" flavors. We source the real deal to give a subtle vanilla boost to the bars.',
  tags: [],
  msrpDollars: 49.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:16.971Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
